interface UseTrackSignUp {
  getPlanName(code: string): string;
}

const PLAN_NAMES = new Map<string, string>([
  ['free', 'Free'],
  ['plus_annual', 'Plus Annual'],
  ['plus_monthly', 'Plus Monthly'],
  ['essential_annual', 'Essential Annual'],
]);

export const useTrackSignup = (): UseTrackSignUp => {
  const getPlanName = (code: string): string => PLAN_NAMES.get(code) || 'free';
  return {
    getPlanName,
  };
};
